import classnames from 'classnames';
import { AnimatePresence, m as motion } from 'framer-motion';
import { useState } from 'react';
import { Partner } from '@/entities/partner';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import { useSetOpenedPopupsState } from '@/shared/atoms/opened-popups';
import OrganizeDetailPopup, {
    ORGANIZE_DETAIL_POPUP,
} from '@/shared/components/popups/OrganizeDetailPopup/OrganizeDetailPopup';
import OrganizeFormPopup from '@/shared/components/popups/OrganizeFormPopup';
import { tp } from '@/shared/lib/typograf';
import OrganizeCategoryItem from '../../shared/OrganizeCategoryList';
import Typografed from '../../shared/Typografed';

export type OrganizeSimpleSectionProps = {
    title: string;
    partners: Partner[];
    description: string;
};

type Props = React.HTMLAttributes<HTMLElement> & {
    organizeSimpleSectionProps: OrganizeSimpleSectionProps;
};

const OrganizeSimpleSection = ({ organizeSimpleSectionProps, ...props }: Props) => {
    const { openPopup } = useSetOpenedPopupsState();
    const device = useMediaQueryDeviceStateValue();
    const isDesktop = device === 'desktop';

    const [selectedPartner, setSelectedPartner] = useState<Partner | null>(null);

    const handleActivePartner = (partner: Partner | null) => {
        setSelectedPartner(partner);
        openPopup(ORGANIZE_DETAIL_POPUP);
    };

    return (
        organizeSimpleSectionProps.partners &&
        organizeSimpleSectionProps.partners.length > 0 && (
            <section
                className={classnames(
                    'organize-section organize-section__simple js-header-theme-trigger js-bg-trigger',
                    props.className,
                )}
                {...props}
            >
                <div className="organize-section__wrapper wrapper">
                    <div className="organize-section-title organize-section-title--simpe h3">
                        <Typografed>{organizeSimpleSectionProps.title}</Typografed>
                    </div>

                    <div className="organize-section-content">
                        {organizeSimpleSectionProps.description && (
                            <div className="organize-section-content-left">
                                <div
                                    className="organize-section-content-left__text text-l wysiwyg"
                                    dangerouslySetInnerHTML={{ __html: tp(organizeSimpleSectionProps.description) }}
                                ></div>
                            </div>
                        )}

                        <AnimatePresence mode="wait">
                            <motion.div
                                className="organize-section-content-right"
                                variants={{
                                    initial: {
                                        opacity: 0,
                                    },
                                    animate: {
                                        opacity: 1,
                                    },
                                    exit: {
                                        opacity: 0,
                                    },
                                }}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                            >
                                {organizeSimpleSectionProps.partners.length > 0 && (
                                    <div className="organize-content-category-block organize-content-category-block--simple">
                                        <OrganizeCategoryItem
                                            partners={organizeSimpleSectionProps.partners}
                                            onSelectPartner={handleActivePartner}
                                        />
                                    </div>
                                )}
                            </motion.div>
                        </AnimatePresence>
                    </div>
                </div>

                <OrganizeDetailPopup partner={selectedPartner} />
                <OrganizeFormPopup />
            </section>
        )
    );
};

export default OrganizeSimpleSection;
